import {
  useLocation,
  useNavigate,
  useParams as useRouterParams,
  useSearchParams as useRouterSearchParams,
  type LinkProps as RouterLinkProps,
} from 'react-router-dom';

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    refresh: () => window.location.reload(),
    prefetch: async () => {
      // no-op em SPA
    },
  };
}

export function usePathname(): string {
  return useLocation().pathname;
}

export function useParams<T extends Record<string, string | undefined> = Record<string, string>>() {
  return useRouterParams() as T;
}

export function useSearchParams(): ReturnType<typeof useRouterSearchParams> {
  return useRouterSearchParams();
}

export type LinkProps = Omit<RouterLinkProps, 'to'> & {
  href: string;
};
